module.exports = "/fonts/aktiv-grotesk-w01.ttf?53c71a30bdde61a57edc0162854d15ee";